import {Component} from '@angular/core';
import { NgxSmartModalModule } from 'ngx-smart-modal';

@Component({
    selector: 'app-error-modal',
    templateUrl: './error-modal.component.html',
    styleUrls: ['./error-modal.component.scss'],
    standalone: true,
    imports: [NgxSmartModalModule]
})
export class ErrorModalComponent {
  public message = '';

  constructor() {
  }

  public dataAdded(data: { message: string }): void {
    this.message = data.message;
  }
}


